import { authType } from 'api/auth';
import { Envs } from 'context/Auth/common/enums';

export const isSaaS = () => {
  return authType === Envs.SAAS;
};
